<template>
    <div class="condition-banner" :class="{ expanded }" @click="toggleExpanded">
        <div v-show="!expanded"
            style="cursor: pointer;font-size: 2em; font-weight: 500; align-content: center; text-align: center; color: rgb(0, 63, 117); padding: 10px;">
            {{ showTitle() }}
        </div>
        <div v-show="expanded">
            <div style="display: flex; justify-content: center;">
                <div class="back" @click.stop="goBack" v-if="showBackButton">Back</div>
            </div>
            <div class="alphabet" v-if="!showconditions">
                <div class="alphabet-letters" v-for="letter in alphabetLetters" :key="letter"
                    @click.stop="filterconditions(letter)">
                    {{ letter }}
                </div>
                <div v-if="alphabetLetters.length === 0">No items available</div>
            </div>
            <div class="conditions-list-container">
                <div class="conditions-list" v-if="showconditions">
                    <router-link v-for="condition in filteredconditions" :key="condition.route" :to="condition.route">
                        <div class="conditions-list-item">
                            {{ condition.name.replace(/\(.*?\)/g, '').trim() }}
                        </div>
                    </router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import conditionsbannerScript from '../../assets/js/conditionsbannerScript';
export default {
    ...conditionsbannerScript
}
</script>

<style src="../../assets/css/conditionsbannerStyle.css" />